import { render, staticRenderFns } from "./StudentFreeNoteEdit.vue?vue&type=template&id=e78eb334&scoped=true"
import script from "./StudentFreeNoteEdit.vue?vue&type=script&lang=js"
export * from "./StudentFreeNoteEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentFreeNoteEdit.vue?vue&type=style&index=0&id=e78eb334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78eb334",
  null
  
)

export default component.exports